export default function getPhotoUrl (prototype) {
  if (prototype?.products?.[0]?.photoUrls?.[0]) {
    return prototype.products[0].photoUrls[0]
  }
  if (Array.isArray(prototype?.order?.fitting) && prototype?.order?.fitting?.[0]?.images?.[0]) {
    return prototype.order.fitting[0].images[0]
  }
  if (prototype?.order?.fitting?.images?.[0]) {
    return prototype.order.fitting.images[0]
  }
  if (prototype?.sketch?.images?.[0]) {
    return prototype.sketch.images[0]
  }
  return ''
}
